module.exports = __webpack_public_path__ + "static/img/woniu.9f3045e9.png";